<template>
  <div id="AccountRecCatalogs" class="Main-Content">
    <Page
      :title="$t('Recommendations.catalogs')"
      size="fullWidth"
    >
      <Card>
        <DataTable
          :columns="[
            {
              key: 'id',
              label: $t('ID')
            },
            {
              key: 'name',
              label: $t('Name')
            },
            {
              key: 'domain',
              label: $t('Domain')
            },
            {
              key: 'languageCode',
              label: $t('Language')
            },
            {
              key: 'currencyCode',
              label: $t('Currency')
            },
            {
              key: 'uniqueItemsFp',
              label: $t('Recommendations.totalItems'),
              format: 'integer'
            }
          ]"
          :rows="catalogs"
          :row-actions="row => [
            {
              label: $t('Recommendations.viewImports'),
              onAction: () => $router.push({name: 'AccountRecCatalogImports', params:{catalogId: row.id}})
            }
          ]"
          :loading="isLoading"
        />
      </Card>
    </Page>
  </div>
</template>

<script>

export default {
  data() {
    return {
      catalogs: [],
      isLoading: false
    }
  },
  created() {
    this.refreshList()
  },
  mounted() {
    if (!this.theUser.recommendationsEnabled || !this.theUser.hasRecommendationsAccess) {
      this.$router.push('/account/profile/')
    }
  },
  methods: {
    refreshList() {
      this.isLoading = true
      this.api.getCatalogs()
        .then((data) => {
          this.catalogs = data
        })
        .catch(this.apiCatch)
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
